export interface Project {
  headline: string;
  link?: { label: string; url: string };
  description: string;
  technologies: string[];
}

export const projects: Project[] = [
  {
    headline: "Vercora",
    link: { label: "Vercora", url: "https://www.vercora.xyz/" },
    description:
      "Outcome markets platform on Solana: Anchor program (`vercora`), TypeScript SDK on npm (`@vercora-protocol/sdk`), and a Vite + React web client with wallet adapters—built for operators, builders, and communities (self-serve tooling plus curated help for selected ideas).",
    technologies: [
      "TypeScript",
      "React",
      "Vite",
      "Solana",
      "Rust",
      "Anchor",
      "Web3",
      "Smart contract",
      "Node.js",
    ],
  },
  {
    headline: "Full-stack GIS / mapping platform",
    link: { label: "CRP", url: "https://climate-resilience-platform.org/" },
    description:
      "Frontend mapping with MapLibre GL JS and Cloud Optimized GeoTIFF; backend with Express, GDAL, MapServer WMS, PostgreSQL/PostGIS.",
    technologies: [
      "Vite 6",
      "TypeScript",
      "Tailwind CSS 4",
      "MapLibre GL JS",
      "Express",
      "GDAL",
      "MapServer WMS",
      "GeoTIFF",
      "PostgreSQL",
      "PostGIS",
      "AWS",
    ],
  },
  {
    headline: "HaveMore",
    link: { label: "HaveMore", url: "https://www.havemore.fi/" },
    description:
      "Build platform for simplifying access to digital income products for institutions, fund managers, and advisors.",
    technologies: [
      "Solana",
      "Rust",
      "Anchor",
      "TypeScript",
      "Node.js",
      "AWS",
      "Web3",
      "Smart contract",
    ],
  },
  {
    headline: "Sol Potato NFT",
    description:
      "NFT community launch with Node.js, React, Web3, Solana, Anchor & Rust. Token launch platform and whitelabel RWA page; pre-liquid token smart contract.",
    technologies: [
      "Node.js",
      "React",
      "Web3",
      "Bash",
      "Solana",
      "Anchor",
      "Rust",
      "NFT",
      "Serverless",
      "AWS",
      "Smart contract",
    ],
  },
  {
    headline: "Reap App",
    link: { label: "Reap App", url: "https://www.reapapp.io" },
    description:
      "Mobile app (Expo, Redux, Jest); API with Rust, TypeScript, Node.js, AuroraDB, Terraform, AWS. AI assistant with MongoDB, Langchain, Claude 3.5, OpenAI. GraphQL server with TypeScript, Apollo Server, Serverless, ElasticSearch.",
    technologies: [
      "Expo",
      "Redux",
      "Rust",
      "TypeScript",
      "Node.js",
      "AuroraDB",
      "Terraform",
      "AWS",
      "MongoDB",
      "Langchain",
      "Claude",
      "OpenAI",
      "GraphQL",
      "Apollo",
      "ElasticSearch",
    ],
  },
  {
    headline: "Solana smart contract · Crypto fundraising",
    description: "Merit-based crypto fundraising platform on Solana.",
    technologies: ["Solana", "Rust", "Anchor", "Smart contract", "Web3"],
  },
  {
    headline: "Visual Motivator",
    link: {
      label: "Visual Motivator",
      url: "https://www.leadingng.com/app/visual-motivator",
    },
    description:
      "Mobile app for daily motivational quotes, a personal visual board for goals and images, reminders, optional biometric lock, and on-device storage.",
    technologies: ["React Native", "TypeScript"],
  },
  {
    headline: "Open metaverse (Mona)",
    link: { label: "Mona", url: "https://monaverse.com" },
    description:
      "New features and products for the open metaverse: TypeScript, Node.js, React, Vue.js, Terraform, AWS, Web3, IPFS, MongoDB, Ethereum, NFT & serverless.",
    technologies: [
      "TypeScript",
      "Node.js",
      "React",
      "Vue.js",
      "Terraform",
      "AWS",
      "Web3",
      "IPFS",
      "MongoDB",
      "Ethereum",
      "NFT",
      "Serverless",
    ],
  },
  {
    headline: "Swappable, All Star, ASM Cortex, Gods & Goblins",
    link: { label: "Think Agents", url: "https://www.thinkagents.ai/" },
    description:
      "Swappable platform, All Star box reveal, ASM Cortex, Gods & Goblins minting. Node.js, React, Next.js, Terraform, AWS, Web3, Infura, Alchemy, Ethereum, NFT & serverless.",
    technologies: [
      "Node.js",
      "React",
      "Next.js",
      "Terraform",
      "AWS",
      "Web3",
      "Infura",
      "Alchemy",
      "Ethereum",
      "NFT",
      "Serverless",
    ],
  },
  {
    headline: "Oogy Collection",
    description:
      "Developed list of NFTs, mint and experience for the NFT holders.",
    technologies: [
      "Solana",
      "Rust",
      "Anchor",
      "TypeScript",
      "Web3",
      "Smart contract",
    ],
  },
  {
    headline: "MATTR VII & NZ Covid Pass",
    link: { label: "MATTR", url: "https://www.mattr.global" },
    description:
      "MATTR VII platform and NZ Covid Pass. TypeScript, Node.js, React Native, React, Postgres, RealmDB, Redis, Docker, AWS, Vault, Helm, K8s. W3C standards: DIDs, Verifiable Credentials, BBS+ Signatures, OIDC.",
    technologies: [
      "TypeScript",
      "Node.js",
      "React Native",
      "React",
      "PostgreSQL",
      "RealmDB",
      "Redis",
      "Docker",
      "AWS",
      "Vault",
      "Helm",
      "K8s",
      "DIDs",
      "Verifiable Credentials",
    ],
  },
  {
    headline: "Fisher Funds online portal",
    link: { label: "Fisher Funds", url: "https://online.fisherfunds.co.nz" },
    description:
      "New design and features for the Fisher Funds online portal. React, TypeScript, Redux, RxJS, Jest, Cypress; Node.js, Postgres, Redis, Heroku, CircleCI.",
    technologies: [
      "React",
      "TypeScript",
      "Redux",
      "RxJS",
      "Jest",
      "Cypress",
      "Node.js",
      "PostgreSQL",
      "Redis",
      "Heroku",
      "CircleCI",
      "AWS",
    ],
  },
  {
    headline: "YourPlayer & Bootleg Apps",
    description:
      "CI/CD with AWS CodePipeline, CodeBuild, CodeDeploy, GitHub. API & socket systems with Silverstripe (PHP), Aurora DB, SQS, Node.js (TypeScript), Redis. Mobile app with React Native, Redux, Jest, Firebase.",
    technologies: [
      "AWS",
      "PHP",
      "Node.js",
      "TypeScript",
      "Redis",
      "React Native",
      "Redux",
      "Jest",
      "Firebase",
    ],
  },
];
